import axios from '@/api/axios';
import {toQueryString} from '@/api/queryString';
import type {
  AdminBusinessAffiliateTier,
  AdminBusinessReferral,
  AdminPaginatedEnvelope,
  AffiliateReferralListParams,
  CreateAffiliateTierPayload,
  DisqualifyAffiliateReferralPayload,
  UpdateAffiliateTierPayload,
} from '@/types';

const BASE_URL = '/v2/admin/business-affiliate';

export const businessAffiliateService = {
  getTiers: async (): Promise<AdminBusinessAffiliateTier[]> => {
    const response = await axios.get<{data: AdminBusinessAffiliateTier[]}>(
      `${BASE_URL}/tiers`,
    );
    return response.data?.data ?? [];
  },

  createTier: async (
    payload: CreateAffiliateTierPayload,
  ): Promise<AdminBusinessAffiliateTier> => {
    const response = await axios.post<AdminBusinessAffiliateTier>(
      `${BASE_URL}/tiers`,
      payload,
    );
    return response.data;
  },

  updateTier: async (
    tierId: string,
    payload: UpdateAffiliateTierPayload,
  ): Promise<AdminBusinessAffiliateTier> => {
    const response = await axios.patch<AdminBusinessAffiliateTier>(
      `${BASE_URL}/tiers/${tierId}`,
      payload,
    );
    return response.data;
  },

  setDefaultTier: async (
    tierId: string,
  ): Promise<AdminBusinessAffiliateTier> => {
    const response = await axios.post<AdminBusinessAffiliateTier>(
      `${BASE_URL}/tiers/${tierId}/default`,
    );
    return response.data;
  },

  getReferrals: async (
    filters: AffiliateReferralListParams,
  ): Promise<AdminPaginatedEnvelope<AdminBusinessReferral[]>> => {
    const {isFlagged, ...rest} = filters;
    const urlParams = toQueryString({
      page: 0,
      limit: 10,
      ...rest,
      ...(isFlagged ? {isFlagged: true} : {}),
    });
    const response = await axios.get<
      AdminPaginatedEnvelope<AdminBusinessReferral[]>
    >(`${BASE_URL}/referrals?${urlParams}`);
    return {...response.data, data: response.data?.data};
  },

  disqualifyReferral: async (
    referralId: string,
    payload: DisqualifyAffiliateReferralPayload,
  ): Promise<AdminBusinessReferral> => {
    const response = await axios.post<AdminBusinessReferral>(
      `${BASE_URL}/referrals/${referralId}/disqualify`,
      payload,
    );
    return response.data;
  },
};
